module.exports = __webpack_public_path__ + "assets/img/map-icon-5.f61eaadf.png";